export const state = {
  1: {
    name: 'Delboni Auriemo',
    urlName: 'delboniauriemo',
    whatsappName: 'DELBONI',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'DelboniSvg',
  },
  2: {
    name: 'Lavoisier',
    urlName: 'lavoisier',
    whatsappName: 'LAVOISIER',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'LavoisierSvg',
  },
  3: {
    name: 'Bronstein',
    urlName: 'bronstein',
    whatsappName: 'BRONSTEIN',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'BronsteinSvg',
  },
  4: {
    name: 'Lamina',
    urlName: 'lamina',
    whatsappName: 'LAMINA',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'LaminaSvg',
  },
  8: {
    name: 'Frischmann',
    urlName: 'labfa',
    whatsappName: 'FRISCHMANN',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'FrischmannSvg',
  },
  10: {
    name: 'Alvaro',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    urlName: 'alvaro',
    whatsappName: 'ALVARO',
    logo: 'AlvaroSvg',
  },
  11: {
    name: 'Labpasteur',
    urlName: 'labpasteur',
    whatsappName: 'LABPASTEUR',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'LabpasteurSvg',
  },
  12: {
    name: 'Image',
    urlName: 'imagememorial',
    whatsappName: 'IMAGE',
    collaboratorVaccineCampaign: true,
    logo: 'ImageSvg',
  },
  13: {
    name: 'Lamina SC',
    urlName: 'laminadiagnosticos',
    whatsappName: 'VITA',
    logo: 'LaminaScSvg',
  },
  14: {
    name: 'Atalaia',
    urlName: 'atalaia',
    whatsappName: 'ATALAIA',
    collaboratorVaccineCampaign: true,
    logo: 'AtalaiaSvg',
  },
  15: {
    name: 'Exame',
    urlName: 'laboratorioexame',
    whatsappName: 'EXAME',
    collaboratorVaccineCampaign: true,
    logo: 'ExameSvg',
  },
  17: {
    name: 'CDPI Niteroi',
    urlName: 'cdpiniteroi',
    whatsappName: 'CDPI NITEROI',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'CdpiNiteroiSvg',
  },
  19: {
    name: 'Alta',
    whatsappName: 'ALTA',
    urlName: 'altadiagnosticos',
    logo: 'AltaSvg',
    check_service_desk: {
      iconClass: 'di-icon-altaAttendant',
      title: 'Será preciso continuar seu atendimento na unidade.',
      subtitle: 'Ao chegar na unidade, dirija-se a recepção para que um de nossos antendentes continue com seu atendimento.',
      labelBtn: 'Finalizar check-in',
    },
    exams_service_desk: {
      iconClass: 'di-icon-altaAttendant',
      title: 'Será preciso continuar seu atendimento na unidade.',
      subtitle: 'Ao chegar na unidade, dirija-se a recepção para que um de nossos antendentes continue com seu atendimento.',
      btnLabel: 'Finalizar check-in',
    },
    end_flow_success: {
      mainPage: {
        title: 'Já entrou na unidade?',
        subtitle: 'Quando entrado na unidade, selecione <strong>“Entrei na unidade”</strong>, para ser chamado por um atendente.',
      },
      modalArrived: {
        title: 'Você já entrou na unidade?',
        subtitle: 'Ao confirmar sua entrada, os atendentes poderão te recepcionar para continuar com seu atendimento.',
      },
      modalNotArrived: {
        title: 'Fique tranquilo!',
        subtitle: 'Ao entrar na unidade, digite novamente seu CPF e clique no botão “Entrei na unidade!”',
      },
      btnYesLabel: 'Entrei na unidade',
      btnNoLabel: 'Ainda não entrei na unidade',
    },
    queue_end_flow: {
      icon: '</span><span class="di di-icon-altaAttendant"></span>',
      title: 'você será recepcionado por um de nossos atendentes.',
    },
  },
  24: {
    name: 'Sergio Franco',
    urlName: 'sergiofranco',
    whatsappName: 'SERGIOFRANCO',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'SergioFrancoSvg',
  },

  // TODO logo muito semelhando o CDPI Niteroi! É possível manter só um??
  25: {
    name: 'CDPI Rio',
    urlName: 'cdpirio',
    whatsappName: 'CDPI Rio',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'CdpiRioSvg'
  },
  27: {
    name: 'Cytolab',
    urlName: 'cytolab',
    whatsappName: 'CYTOLAB',
    collaboratorVaccineCampaign: true,
    logo: 'CytolabSvg',
  },
  28: {
    name: 'Multi-Imagem Petropolis',
    urlName: 'multi-imagem-petropolis',
    whatsappName: 'MULTIIMAGEMPETROPOLIS',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'MultiImagemSvg',
  },
  29: {
    name: 'Multi-Imagem Rio',
    urlName: 'multi-imagem-rio',
    whatsappName: 'MULTIIMAGEMRIO',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'MultiImagemSvg',
  },
  32: {
    name: 'Previlab',
    urlName: 'previlab',
    whatsappName: 'PREVILAB',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'PrevilabSvg',
  },
  34: {
    name: 'Cerpe',
    urlName: 'cerpe',
    whatsappName: 'CERPE',
    collaboratorVaccineCampaign: true,
    logo: 'CerpeSvg',
  },
  37: {
    name: 'Gilson Cidrim',
    urlName: 'gilsoncidrim',
    whatsappName: 'GILSONCIDRIM',
    logo: 'GilsonCidrimSvg',
  },
  39: {
    name: 'Oswaldo Cruz',
    urlName: 'oswaldocruz',
    whatsappName: 'OSWALDOCRUZ',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'OswaldoCruzSvg',
  },
  40: {
    name: 'Leme',
    urlName: 'lableme',
    whatsappName: 'LEME',
    collaboratorVaccineCampaign: true,
    logo: 'LemeSvg',
  },
  41: {
    name: 'Vital Brasil',
    urlName: 'vitalbrasil',
    whatsappName: 'VITALBRASIL',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'VitalBrasilSvg',
  },
  42: {
    name: 'Salomão Zoppi',
    urlName: 'salomaozoppi',
    whatsappName: 'SALOMAOZOPPI',
    collaboratorVaccineCampaign: true,
    logo: 'SalomaoZoppiSvg'
  },
  59: {
    name: 'Valeclin',
    urlName: 'valeclin',
    whatsappName: 'VALECLIN',
    logo: 'ValeclinSvg',
  },
  89: {
    name: 'Unimed Cuiaba',
    urlName: 'unimedcuiaba',
    whatsappName: 'UNIMEDCUIABA',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'UnimedCuiabaSvg',
  },
  101: {
    name: 'Cedic Cedilab',
    urlName: 'cediccedilab',
    whatsappName: 'CEDILAB',
    collaboratorVaccineCampaign: true,
    logo: 'CedicCedilabSvg',
  },
  102: {
    name: 'Deliberato',
    urlName: 'deliberato',
    whatsappName: 'DELIBERATO',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'DeliberatoSvg',
  },
  103: {
    name: 'Padrão',
    urlName: 'padrao',
    whatsappName: 'PADRAO',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'PadraoSvg',
  },
  105: {
    name: 'Itulab',
    urlName: 'itulab',
    whatsappName: 'ITULAB',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'ItulabSvg',
  },
  107: {
    name: 'Ghanem',
    urlName: 'ghanem',
    whatsappName: 'GHANEM',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: true,
    logo: 'GhanemSvg',
  },
  123: {
    name: 'São Camilo AP',
    urlName: 'saocamiloap',
    whatsappName: 'SÃO CAMILO',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'SaoCamiloSvg',
  },
  126: {
    name: 'São Camilo AC',
    urlName: 'saocamiloac',
    whatsappName: 'SÃO CAMILO',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'SaoCamiloSvg',
  },
  127: {
    name: 'São Camilo RDI',
    urlName: 'saocamilordi',
    whatsappName: 'SÃO CAMILO',
    // Ativar assim que convenio de vacina para colaboradores estiver disponivel para esta marca
    collaboratorVaccineCampaign: false,
    logo: 'SaoCamiloSvg',
  },
};
